import { render, staticRenderFns } from "./TestSignature.vue?vue&type=template&id=8121e4ee&scoped=true&"
import script from "./TestSignature.vue?vue&type=script&lang=js&"
export * from "./TestSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8121e4ee",
  null
  
)

export default component.exports